<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="(showNewEintrag = true) && (eintragIstNeu = true) && (neuerEintrag = { datum: heute })"
            icon
            v-on="on"
            ><v-icon>add</v-icon></v-btn
          >
        </template>
        <span>Neuer Eintrag</span>
      </v-tooltip>
      {{ kasse }}
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <!-- <v-text-field
          v-model='search'
          append-icon='search'
          label='Suchen'
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field> -->
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="12">
        <v-card outlined>
          <v-list-item :key="item">
            <v-list-item-content>
              <v-list-item-title>Aktueller Kassenstand:</v-list-item-title>
              <v-list-item-subtitle>{{ kasse }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action class="title pr-2 green--text">
              {{ summe | money }}
            </v-list-item-action>
          </v-list-item>
        </v-card>
        <v-card outlined class="mt-2">
          <v-virtual-scroll :items="kassenbuch" :height="590" item-height="60">
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id" @click="itembearbeiten(item)">
                <v-list-item-avatar>
                  <v-btn v-if="item.betrag < 1" icon class="red--text"><v-icon>upload</v-icon></v-btn>
                  <v-btn v-else icon disabled class="green--text"><v-icon>check</v-icon></v-btn>
                </v-list-item-avatar>

                <v-divider vertical></v-divider>

                <v-list-item-content class="ml-4">
                  <v-list-item-subtitle>{{ $filters.date(item.datum, "DD.MM.YYYY") }}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.titel }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="subtitle-2 pr-2">
                  {{ item.betrag | money }}
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showNewEintrag" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          <div v-if="eintragIstNeu">Eintrag hinzufügen</div>
          <div v-else>Eintrag bearbeiten</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="showNewEintrag = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="py-2">
              <v-text-field hide-details v-model="neuerEintrag.titel" label="Titel" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pr-2 py-2">
              <v-text-field hide-details v-model="neuerEintrag.betrag" number label="Betrag" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="py-2">
              <v-menu
                ref="neuerEintrag.datum"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field hide-details outlined v-model="formatDatum" label="Datum" v-on="on"></v-text-field>
                </template>
                <v-date-picker
                  prev-icon="keyboard_arrow_left"
                  next-icon="keyboard_arrow_right"
                  v-model="neuerEintrag.datum"
                  locale="de-de"
                  first-day-of-week="1"
                  @input="menu1 = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="pl-2 py-2">
              <v-btn hide-details disabled block class="red--text" height="56" outlined
                >Rechnung<br />hochladen<v-icon>upload</v-icon></v-btn
              >
            </v-col>
            <v-col cols="12" class="py-2">
              <v-textarea hide-details v-model="neuerEintrag.bemerkung" label="Bemerkung" outlined></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="!eintragIstNeu" @click="deleteEintrag(neuerEintrag.id)" icon><v-icon>delete</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showNewEintrag = false">Abbrechen</v-btn>
          <v-btn v-if="eintragIstNeu" class="primary" @click="saveNeuEintrag()" dark text>Speichern</v-btn>
          <v-btn v-else class="primary" @click="saveEintrag(neuerEintrag)">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: ["kasse"],
    data() {
      return {
        neuerEintrag: {},
        heute: new Date().toISOString().substr(0, 10),
        eintragIstNeu: false,
        showNewEintrag: false,
        date: "",
        menu1: "",
        item: "",
        headers: [
          { text: "Betrag", value: "betrag" },
          { text: "Titel", value: "titel" },
          { text: "Datum", value: "datum" },
          { text: "", value: "" },
        ],
        expanded: [],
      };
    },
    computed: {
      summe() {
        let summe = 0;
        this.kassenbuch.forEach((eintrag) => {
          summe += parseFloat(eintrag.betrag);
        });
        return summe;
      },
      formatDatum() {
        if (!this.neuerEintrag.datum) return null;
        return new Date(this.neuerEintrag.datum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      kassenbuch() {
        if (this.$store.state.kassenbucher.loaded === false) {
          this.$store.dispatch("kassenbucher/loadKassenbucher");
        }
        return this.$store.getters["kassenbucher/kassenbucherKasse"](this.kasse);
      },
    },
    methods: {
      itembearbeiten(item) {
        console.log(item);
        this.showNewEintrag = true;
        this.eintragIstNeu = false;
        this.neuerEintrag = item;
      },
      saveNeuEintrag() {
        this.neuerEintrag.kasse = this.kasse;
        this.neuerEintrag.betrag = parseFloat(this.neuerEintrag.betrag);
        this.$store.dispatch("kassenbucher/createKassenbuch", this.neuerEintrag);
        this.neuerEintrag = {};
        this.showNewEintrag = false;
      },
      saveEintrag(eintrag) {
        this.$store.dispatch("kassenbucher/updateKassenbuchData", eintrag);
        this.neuerEintrag = {};
        this.showNewEintrag = false;
      },
      deleteEintrag(id) {
        this.$store.dispatch("kassenbucher/deleteKassenbuchData", id);
        this.neuerEintrag = {};
        this.showNewEintrag = false;
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// kassenbuch.vue?29f98301